<template>
  <div id="L0">
    <div class="wrapper">
      <kg-header />
      <kg-login />
      <kg-footer :toContactEventFlg="false"/>
    </div>
  </div>
</template>

<script>
import * as App from '../../utils/App'
import {KG_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/login/LoginHeader'
import LoginForm from '../components/login/LoginForm'
import Footer from '../components/login/LoginFooter'

export default {
  name: 'Login',
  components: {
    'kg-header': Header,
    'kg-login': LoginForm,
    'kg-footer': Footer
  },
  created () {
    App.removeLocalStorage(KG_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/Login.vue